// extracted by mini-css-extract-plugin
var _1 = "TableOfContents-module__active--P2wYC";
var _2 = "TableOfContents-module__animateUploadProgressBarWidth--RCf_b";
var _3 = "TableOfContents-module__animatedBackground--O52jS";
var _4 = "TableOfContents-module__collapsed--Z7YwG";
var _5 = "TableOfContents-module__level2--dE8RF";
var _6 = "TableOfContents-module__level3--WzxQj";
var _7 = "TableOfContents-module__small--tbHG9";
var _8 = "TableOfContents-module__toc--qfoia";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "collapsed", _5 as "level2", _6 as "level3", _7 as "small", _8 as "toc" }
